import { ValidationMessage } from 'ui';
import { ComplexValue } from 'app/types-shared';
import { ActionPayloadType, CodetableMetadata, ListAction, ListBranchItem, ListBranchModel, Visibility } from './types-store';
import { RowSelection } from './types';

export const ACTION = {
  CLEAR_ALL: 'LINK_CODES:CLEAR_ALL',

  REQUEST_BREADCRUMBS: 'LINK_CODES:REQUEST_BREADCRUMBS',
  RECEIVE_BREADCRUMBS: 'LINK_CODES:RECEIVE_BREADCRUMBS',
  FAIL_BREADCRUMBS: 'LINK_CODES:FAIL_BREADCRUMBS',

  REQUEST_METADATA: 'LINK_CODES:REQUEST_METADATA',
  RECEIVE_METADATA: 'LINK_CODES:RECEIVE_METADATA',
  FAIL_METADATA: 'LINK_CODES:FAIL_METADATA',

  CLEAR_LIST: 'LINK_CODES:CLEAR_LIST',
  REQUEST_LIST_BRANCH: 'LINK_CODES:REQUEST_LIST_BRANCH',
  RECEIVE_LIST_BRANCH: 'LINK_CODES:RECEIVE_LIST_BRANCH',
  FAIL_LIST_BRANCH: 'LINK_CODES:FAIL_LIST_BRANCH',

  EXPAND_LIST_BRANCH_ITEM: 'LINK_CODES:EXPAND_LIST_BRANCH_ITEM',
  ADD_LIST_ACTION: 'LINK_CODES:ADD_LIST_ACTION',

  CLEAR_ACTION_ERRORS: 'LINK_CODES:CLEAR_ACTION_ERRORS',

  UPDATE_CODETABLE: 'LINK_CODES:UPDATE_CODETABLE',
  UPDATE_CATEGORY: 'LINK_CODES:UPDATE_CATEGORY',
  UPDATE_ACTIVE_VALUE: 'LINK_CODES:UPDATE_ACTIVE_VALUE',
  UPDATE_INCLUDE_INACTIVE: 'LINK_CODES:UPDATE_INCLUDE_INACTIVE',

  UPDATE_VISIBILITY: 'LINK_CODES:UPDATE_VISIBILITY',
  SELECT_ROW: 'LINK_CODES:SELECT_ROW',

  REQUEST_SAVE_CHANGES: 'LINK_CODES:REQUEST_SAVE_CHANGES',
  RECEIVE_SAVE_CHANGES: 'LINK_CODES:RECEIVE_SAVE_CHANGES',
  FAIL_SAVE_CHANGES: 'LINK_CODES:FAIL_SAVE_CHANGES',
  CANCEL_CHANGES: 'LINK_CODES:CANCEL_CHANGES'
};

export class ClearAll {
  public type: string = ACTION.CLEAR_ALL;
}

export class RequestBreadcrumbs {
  public type: string = ACTION.REQUEST_BREADCRUMBS;
}

export class ReceiveBreadcrumbs {
  public type: string = ACTION.RECEIVE_BREADCRUMBS;
  constructor(public options: ComplexValue<number>[]) { }
}

export class FailBreadcrumbs {
  public type: string = ACTION.FAIL_BREADCRUMBS;
}

export class RequestMetadata {
  public type: string = ACTION.REQUEST_METADATA;
  constructor(public id: number) { }
}

export class ReceiveMetadata {
  public type: string = ACTION.RECEIVE_METADATA;
  constructor(public id: number, public metadata: CodetableMetadata) { }
}

export class FailMetadata {
  public type: string = ACTION.FAIL_METADATA;
  constructor(public id: number) { }
}

export class ClearList {
  public type: string = ACTION.CLEAR_LIST;
  constructor(public model: ListBranchModel) { }
}

export class RequestListBranch {
  public type: string = ACTION.REQUEST_LIST_BRANCH;
  constructor(public model: ListBranchModel, public id: number) { }
}

export class ReceiveListBranch {
  public type: string = ACTION.RECEIVE_LIST_BRANCH;
  constructor(
    public model: ListBranchModel, public id: number,
    public listBranchItems: ListBranchItem[], public numberOfResults: number, public clearList: boolean
  ) { }
}

export class FailListBranch {
  public type: string = ACTION.FAIL_LIST_BRANCH;
  constructor(public model: ListBranchModel, public id: number) { }
}

export class ExpandListBranchItem {
  public type: string = ACTION.EXPAND_LIST_BRANCH_ITEM;
  constructor(public id: number) { }
}

export class AddListAction {
  public type: string = ACTION.ADD_LIST_ACTION;
  constructor(public actions: ListAction[]) { }
}

export class ClearActionErrors {
  public type: string = ACTION.CLEAR_ACTION_ERRORS;
  constructor(public fixListActions: boolean) { }
}

export class UpdateCodetable {
  public type: string = ACTION.UPDATE_CODETABLE;
  constructor(public value: ComplexValue<number>) { }
}

export class UpdateCategory {
  public type: string = ACTION.UPDATE_CATEGORY;
  constructor(public value: ComplexValue<number>) { }
}

export class UpdateActiveValue {
  public type: string = ACTION.UPDATE_ACTIVE_VALUE;
  constructor(public value: ComplexValue<number>) { }
}

export class UpdateIncludeInactive {
  public type: string = ACTION.UPDATE_INCLUDE_INACTIVE;
  constructor(public value: boolean) { }
}

export class UpdateVisibility {
  public type: string = ACTION.UPDATE_VISIBILITY;
  constructor(public visibility: Visibility) { }
}

export class SelectRow {
  public type: string = ACTION.SELECT_ROW;
  constructor(public selection: RowSelection) { }
}

export class RequestSaveChanges {
  public type: string = ACTION.REQUEST_SAVE_CHANGES;
  constructor(
    public model: ListBranchModel,
    public activeValue: ComplexValue<number>,
    public activeType: ActionPayloadType
  ) { }
}

export class ReceiveSaveChanges {
  public type: string = ACTION.RECEIVE_SAVE_CHANGES;
  constructor(
    public model: ListBranchModel,
    public activeValue: ComplexValue<number>,
    public activeType: ActionPayloadType
  ) { }
}

export class FailSaveChanges {
  public type: string = ACTION.FAIL_SAVE_CHANGES;
  constructor(
    public model: ListBranchModel,
    public activeValue: ComplexValue<number>,
    public activeType: ActionPayloadType,
    public actionErrors: ValidationMessage[]
  ) { }
}

export class CancelChanges {
  public type: string = ACTION.CANCEL_CHANGES;
}
